import React, { useContext } from "react";
import { UserInfo } from "../context";
import SuperAdminRoute from "./SuperAdminRoute";
import CommissaryRoute from "./CommissaryRoute";
import MerchantRoute from "./MerchantRoute";
import CommissaryEmployeeRoute from "./CommissaryEmployeeRoute";

function AllRoute() {
  const { userData } = useContext(UserInfo);
  return (
    <>
      {userData.ready && userData.data.module === "commissary" ? (
        <CommissaryRoute />
      ) : userData.ready && userData.data.module === "merchant" ? (
        <MerchantRoute />
      ) : userData.ready && userData.data.module === "superadmin" ? (
        <SuperAdminRoute />
      ) : userData.ready && userData.data.module === "commissary-employee" ? (
        <CommissaryEmployeeRoute />
      ) : (
        ""
      )}
    </>
  );
}

export default AllRoute;
